<section *ngIf="customGiftCardProduct && customGiftCardProduct.length !== 0 && !unlimitedAmountMode">
  <div class="container giftcard-custom-container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <h3>{{ 'Choose your own amount' | translate }}</h3>
        <p>{{ 'Choose your own amount between' | translate }} {{min}} &amp; {{max}} {{ 'currency_sign' | translate }}
        </p>
        <div class="row justify-content-center pt-4">
          <div class="col-12 col-sm-6 col-md-5 col-lg-4 p-0 pr-sm-4">
            <div class="group_input">
              <!-- <p class="tooltiptext tooltip-top tooltip-error" style="opacity: 1; visibility:visible">
                <i class="fas fa-exclamation-triangle"></i>
                <br>
                <span>Betrag zwischen 25 &amp; 500€ eingeben</span>
              </p> -->
              <app-input-number [name]="'customPrice'" [(ngModel)]="customPrice" appValidateNumber [min]="min" [max]="max"></app-input-number>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-5 col-lg-4 p-0 pl-sm-4">
            <app-button [title]="'Order' | translate" (click)="onClick(customPrice)" [fullSize]="true"></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
